import React from "react";

const HomeIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1631_59" x="0" y="0" width="25" height="24">
        <rect x="0.822754" width="23.6962" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1631_59)">
        <path
          d="M6.74661 18.9999H10.0504V13.0576H15.2909V18.9999H18.5947V9.99989L12.6707 5.48066L6.74661 9.99989V18.9999ZM5.26562 20.4999V9.24991L12.6707 3.60571L20.0757 9.24991V20.4999H13.8099V14.5575H11.5314V20.4999H5.26562Z"
          fill="#8692A8"
        />
      </g>
    </svg>
  );
};

export default HomeIcon;
